import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Tracks whether a `sticky top-0` element right below the sentinel is stuck. Sticky offsets are
 * measured from the scroller's content box, so the page's `<main>` padding is the edge that counts.
 */
const useIsStuck = () => {
  const $ = _c(5);
  const [sentinel, setSentinel] = useState(null);
  const [isStuck, setIsStuck] = useState(false);
  let t0;
  let t1;
  if ($[0] !== sentinel) {
    t0 = () => {
      if (!sentinel) {
        return;
      }
      const root = sentinel.closest("main");
      const paddingTop = root ? Number.parseFloat(getComputedStyle(root).paddingTop) : 0;
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        return setIsStuck(!entry.isIntersecting);
      }, {
        root,
        rootMargin: `-${paddingTop}px 0px 100000px 0px`
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t1 = [sentinel];
    $[0] = sentinel;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isStuck) {
    t2 = {
      sentinelRef: setSentinel,
      isStuck
    };
    $[3] = isStuck;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useIsStuck;